import { DetailedHTMLProps, HTMLAttributes } from "react";
import { useFormEditState } from "@/lib/Components/Form/Hooks/useFormEditState";
import { cn } from "@/lib/utils";

export function FormDivider({
  className,
  ...props
}: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>) {
  const { isEditing } = useFormEditState();

  return (
    <div
      {...props}
      className={cn("col-span-full border-b border-gray-200/0", {
        "border-gray-200 border-opacity-100": isEditing,
        className,
      })}
    ></div>
  );
}
